import type SharedMailboxState from "./schema/SharedMailboxState";
import { createStore } from "owa-satcheljs";
import type { MailboxInfo } from "owa-client-types";
import { getAccountKeyForMailboxInfo } from "owa-client-types";

const sharedMailboxStateStores = new Map<string, SharedMailboxState>();

export function getStore(mailboxInfo: MailboxInfo): SharedMailboxState {
    const name = `${getAccountKeyForMailboxInfo(mailboxInfo)}_sharedMailboxState`;
    let cachedStore = sharedMailboxStateStores.get(name);
    if (!cachedStore) {
        const initialStore: SharedMailboxState = {
            initialized: false,
            isSharedMailbox: false,
        };
        /* eslint-disable-next-line owa-custom-rules/invoke-only-in-module-scope -- (https://aka.ms/OWALintWiki)
         * Baseline. DO NOT COPY AND PASTE!, this function can only be called in the module scope.
         *	> Function should only be invoked in module scope */
        const sharedMailboxStateStore = createStore<SharedMailboxState>(name, initialStore)();
        sharedMailboxStateStores.set(name, sharedMailboxStateStore);
        cachedStore = sharedMailboxStateStore;
    }
    
    return cachedStore;
}
